$.fn.CMSTable = function(options) {

    var dataTable;
    var table = this;

    if ($.fn.DataTable.isDataTable( table ) ) {
        dataTable = $(table).DataTable();
        dataTable.destroy();
    }
    var selectionList = [];

    var defaultOrderCol = 0;
    var defaultTargetCol = -1;

    if(options.actions_first_column && options.select){
        defaultOrderCol = 2;
        defaultTargetCol = 1;
    }else if(options.actions_first_column && !options.select){
        defaultOrderCol = 1;
        defaultTargetCol = 0;
    }else if(!options.actions_first_column && options.select){
        defaultOrderCol = 1;
        defaultTargetCol = -1;
    }
    var options = $.extend({
        renders: {},
        orderable: {},
        show_clone: false,
        show_delete: true,
        show_edit: true,
        show_pw: false,
        invoice: false,
        pdf: false,
        notification: false,
        annulla: false,
        default_order: (options.default_order ? options.default_order : [[defaultOrderCol, "desc"]]),
        ordering: false,
        footerCallback: null,
        actions_first_column: false,
        scrollY: false,
        scrollX: false,
        scrollCollapse: false,
        fixedColumns: false,
        select: false
    }, options);

    var firstSearch = true;
    var columnDefs = [];
    var apiUrl = table.data("cms-table");

    if(options.select){
        columnDefs.push({
            orderable: false,
            className: 'select-checkbox',
            targets:   0,
            render: function (data, type, row, meta){

                var checked = selectionList.find(o => o == row.id)

                return '<input type="checkbox" name="table-checkbox" value="'+row.id+'" class="form-check custom-checkbox table-checkbox" data-cms-checkbox '+(checked ? 'checked' : '')+'>';
            }
        });
    }
    var actionsCol = {
        targets: defaultTargetCol,
        data: null,
        orderable: false,
        width: "100px",
        className: 'action-col',
        render: function(data, type, row, meta) {
            console.log(row);
            var btns = [
                (options.invoice && ((row) && (row.invoice_required) && (row.invoice_required == 1) && (row.invoice_number)) ? "<button class='btn btn-sm btn-secondary btn-invoice' data-cms-invoice title='Scarica Fattura' data-toggle='tooltip' data-placement='top'>Fattura</button>" : ""),
                (options.notification ? "<button class='btn btn-sm btn-dark btn-notification ml-1' data-cms-notification title='Invia notifiche' data-toggle='tooltip' data-placement='top'><i class='fa fa-paper-plane'></i></button>" : ""),
                ( (options.annulla) ? "<button "+(row.is_annullata ? 'disabled' : '')+" class='btn btn-sm btn-dark annullaPrenotazione ml-1' data-bookingId="+row.id+" title='Annulla prenotazione' data-toggle='tooltip' data-placement='top'><i class='fa fa-undo'></i></button>" : ""),

                (options.pdf ? "<button class='btn btn-sm btn-light btn-pdf' data-cms-pdf title='Scarica PDF' data-toggle='tooltip' data-placement='top'><i class='fa fa-download'></i></button>" : ""),
                ((options.show_pw && ((row && row.roles && row.roles.length > 0) && ['guest', 'admin'].indexOf((row.roles[0].name ?? '')) <= -1)) ? "<button class='btn btn-sm btn-success mr-1 btn-pw' data-cms-pwd title='Impersona' data-toggle='tooltip' data-placement='top'><i class='fa fa-key'></i></button>" : ""),
                (options.show_edit ? "<button class='btn btn-sm btn-primary '           data-cms-view title='Modifica' data-toggle='tooltip' data-placement='top'><i class='fa fa-edit'></i></button>" : ""),
                (options.show_clone ? "<button class='btn btn-sm btn-warning '          data-cms-clone title='Duplica' data-toggle='tooltip' data-placement='top'><i class='fa fa-copy'></i></button>" : ""),
                (options.show_delete ? "<button class='btn btn-sm btn-danger mr-1'      data-cms-delete title='Cancella' data-toggle='tooltip' data-placement='top' "+ ((row && row.confirmed && row.confirmed == 1) ? "disabled='disabled'":  '') +"><i class='fa fa-trash'></i></button>" : "")
            ];

            if(options.actions_first_column){
                btns = btns.reverse();
            }

            for(var i in options.actions){
                var disabled = false;
                var show = true;
                if(options.actions[i].show){
                    show = options.actions[i].show(row)
                }else if(options.actions[i].disable){
                    disabled = options.actions[i].disable(row)
                }
                if(show) {
                    btns.push("<button class='btn btn-sm  " + options.actions[i].class + "' data-cms-button='" + i + "' title='" + (options.actions[i].title ? options.actions[i].title : '') + "' " + (disabled ? 'disabled' : '') + "><i class='glyphicon " + options.actions[i].icon + "'></i> "+(options.actions[i].text ? options.actions[i].text : '') +"</button>");
                }
            }
            return btns.join("");
        }
    };

    if(options.actions_first_column){
        columnDefs.push(actionsCol);
    }

    table.find('th').each(function(i, o) {
        var col = $(o).data('column');
        if (col) {
            var def = {
                targets: i,
                data: col
            }
            if (col == 'id') {
                def.width = '60px';
                def.className = 'id-col';
            }
            if (options.renders[col]) {
                def.render = options.renders[col];
                def.orderable = (options.orderable[col]) ? options.orderable[col] : false;
            }
            def.orderable = (options.orderable[col]) ? options.orderable[col] : false;

            columnDefs.push(def)
        }
    });


    if(!options.actions_first_column){
        columnDefs.push(actionsCol);
    }

    var dataTableOpts = {
        drawCallback: function() {
            $('.btn-invoice:disabled').hide();
            //$('table').parent().addClass('table-responsive');
        },
        footerCallback: options.footerCallback,
        autoWidth: false,
        serverSide: true,
        searching: true,
        pageLength: 50,
        ordering: options.ordering,
        order: options.default_order,
        ajax: {
            url: apiUrl,
            data: function(d) {

                if (!firstSearch) {
                    d.filters = $('[data-cms-filters]').serializeObject();
                }
            }
        },
        columnDefs: columnDefs,
        language: {
            "sEmptyTable": "Nessun dato presente nella tabella",
            "sInfo": "Vista da _START_ a _END_ di _TOTAL_ elementi",
            "sInfoEmpty": "Vista da 0 a 0 di 0 elementi",
            "sInfoFiltered": "(filtrati da _MAX_ elementi totali)",
            "sInfoPostFix": "",
            "sInfoThousands": ".",
            "sLengthMenu": "Visualizza _MENU_ elementi",
            "sLoadingRecords": "Caricamento...",
            "sProcessing": "Elaborazione...",
            "sSearch": "Cerca:",
            "sZeroRecords": "La ricerca non ha portato alcun risultato.",
            "oPaginate": {
                "sFirst": "Inizio",
                "sPrevious": "Precedente",
                "sNext": "Successivo",
                "sLast": "Fine"
            },
            "oAria": {
                "sSortAscending": ": attiva per ordinare la colonna in ordine crescente",
                "sSortDescending": ": attiva per ordinare la colonna in ordine decrescente"
            }
        },
        /*select: {
            style: 'os',
            selector: 'td:first-child'
        },*/
    };

    if(options.scrollCollapse){
        dataTableOpts.scrollY =        options.scrollY;
        dataTableOpts.scrollX =        options.scrollX;
        dataTableOpts.scrollCollapse = options.scrollCollapse;
    }
    if(options.fixedColumns){
        dataTableOpts.fixedColumns = options.fixedColumns;
    }
    if(options.select){
        dataTableOpts.select = options.select;
    }
    dataTable = table.DataTable(dataTableOpts);

    function isAllSelected(){
        //console.log( 'New page length: '+len );
        var info = dataTable.page.info();

        var totalElem = info.end - info.start;
        var totalChecked =  $('[data-cms-checkbox]:checked').length;
        //console.log(totalElem, totalChecked);


        $('[data-cms-selectall]').prop('checked', totalChecked == totalElem);
    }
    function changeSelection(sel){

        if(sel.prop('checked') == true){
            selectionList.push(sel.val())
        }else{
            var checkindex = selectionList.findIndex(o => o == sel.val())
            selectionList.splice(checkindex, 1);
        }
    }
    dataTable.resetSelection = function(){
        selectionList = [];
    }

    if(options.select) {

        $(document).off('change', '[data-cms-selectall]');
        $(document).on('change', '[data-cms-selectall]', function() {
            var selectAll = $(this).is(':checked');

            $('[data-cms-checkbox]').each(function (i, o){
                if($(o).prop('checked') != selectAll){
                    $(o).prop('checked', selectAll);
                    changeSelection($(o));
                }
            });

            if(typeof options.select.onChange == 'function'){
                options.select.onChange(selectionList);
            }
        });

        $(document).off('change', '[data-cms-checkbox]')
        $(document).on('change', '[data-cms-checkbox]', function (e) {

            changeSelection($(this));

            if(typeof options.select.onChange == 'function'){
                options.select.onChange(selectionList)
            }
        });
    }

    dataTable.on( 'draw', function () {

        if(options.select) {
            isAllSelected()
        }
    });


    $(document).off('click', '[data-cms-button]');
    $(document).on('click', '[data-cms-button]', function() {
        var data = dataTable.row($(this).parents('tr')).data();
        var _id = data.id;
        var action = $(this).data('cms-button');
        for(var i in options.actions){
            if(i == action){
                options.actions[i].onClick(data, dataTable)
                break;
            }
        }
    });
    $(document).off('click', '[data-cms-view]');
    $(document).on('click', '[data-cms-view]', function() {
        var data = dataTable.row($(this).parents('tr')).data();
        var _id = data.id;
        window.location.href = apiUrl + '/' + _id + '/edit';
    });

    $(document).off('click', '[data-cms-clone]');
    $(document).on('click', '[data-cms-clone]', function() {
        var data = dataTable.row($(this).parents('tr')).data();
        var _id = data.id;
        window.location.href = apiUrl + '/' + _id + '/clone';
    });

    $(document).off('click', '[data-cms-pdf]');
    $(document).on('click', '[data-cms-pdf]', function() {
        var data = dataTable.row($(this).parents('tr')).data();
        var _code = data.md5_code;
        console.log(apiUrl.replace('admin', '') + '/ticket/' + _code + '/pdf');
        window.location.href = (apiUrl.replace('admin/bookings', 'booking')) + '/ticket/' + _code + '/pdf';
    });

    $(document).off('click', '[data-cms-invoice]');
    $(document).on('click', '[data-cms-invoice]', function() {
        var data = dataTable.row($(this).parents('tr')).data();
        var _code = data.md5_code;
        console.log(apiUrl + '/invoice/' + _code + '/pdf');
        window.location.href = (apiUrl.replace('admin/bookings', 'booking')) + '/invoice/' + _code + '/pdf';
    });

    $(document).off('click', '[data-cms-delete]');
    $(document).on('click', '[data-cms-delete]', function() {
        var data = dataTable.row($(this).parents('tr')).data();
        var _id = data.id;
        if (confirm('Confermare eliminazione?')) {
            $.ajax({
                url: apiUrl + '/' + _id,
                method: 'DELETE',
                success: function(response) {
                    dataTable.ajax.reload();
                },
                dataType: 'json'
            })
        }
    });


    $(document).off('click', '[data-cms-notification]');
    $(document).on('click', '[data-cms-notification]', function(e){
        e.preventDefault();
        var data = dataTable.row($(this).parents('tr')).data();
        var _id = data.id;
        window.location.href = apiUrl +'/'+ _id +'/send-notification';
    });

    $(document).off('click', '[data-cms-pwd]');
    $(document).on('click', '[data-cms-pwd]', function(e){
        e.preventDefault();
        var data = dataTable.row($(this).parents('tr')).data();
        var _id = data.id;
        window.location.href = apiUrl + '/autologin/' + _id;
    });

    $('[data-cms-filters]').off('submit');
    $('[data-cms-filters]').on('submit', function(e) {
        e.preventDefault();
        firstSearch = false;
        dataTable.ajax.reload();
    });

    $('[data-cms-filters]').off('reset');
    $('[data-cms-filters]').on('reset', function(e) {
        var _this = $(this);
        var _container = _this.closest("form");
        //select2
        _container.find('select.select2-hidden-accessible').each(function(i, el){
            $(el).val(null).trigger('change');
        });
        firstSearch = true;
        setTimeout(function(){
            dataTable.ajax.reload();
        },300);
    });

    $('#accordionFilters').off('hide.bs.collapse').off('shown.bs.collapse');

    $('#accordionFilters').on('hide.bs.collapse', function() {
        $('.filters-arrow').addClass('glyphicon-chevron-down').removeClass('glyphicon-chevron-up')
    }).on('shown.bs.collapse', function() {
        $('.filters-arrow').removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up')
    })

    return dataTable;
}
